import React from 'react'
import { IconContext } from 'react-icons'
import { FaGithub } from 'react-icons/fa'
import FaInfinityIcon from '../../../components/Icons/FaInfinityIcon'
import { useDarkMode } from '../../../components/Theme/Theme.hook'
import {
  ActionControl,
  Actions,
  Brand,
  BrandMark,
  BrandName,
  Container,
  IconButton,
} from './Header.styles'

const Header = () => {
  const { theme, toggleTheme } = useDarkMode()
  const isDark = theme === 'dark'

  const handleGithub = () => {
    window.open('https://github.com/oscarossesa', '_blank', 'noopener,noreferrer')
  }

  return (
    <Container>
      <Brand href="/" aria-label="Home — Oscar Osses">
        <BrandMark>
          <FaInfinityIcon title="" size="16" />
        </BrandMark>
        <BrandName>Oscar Osses</BrandName>
      </Brand>

      <Actions>
        <ActionControl
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={toggleTheme}
          type="button"
        >
          {isDark ? 'Light' : 'Dark'}
        </ActionControl>

        <IconContext.Provider value={{ color: 'currentColor', size: '16' }}>
          <IconButton
            aria-label="GitHub repository"
            onClick={handleGithub}
            type="button"
          >
            <FaGithub title="GitHub repository" />
          </IconButton>
        </IconContext.Provider>
      </Actions>
    </Container>
  )
}

export default Header
